const API_BASE = process.env.REACT_APP_API_URL || '';

console.log(`[API Client] Initialized with API_BASE: "${API_BASE}"`);

export const api = {
    async searchByQR(qrCode) {
        console.log(`[API] Searching by QR: ${qrCode}`);
        const url = `${API_BASE}/api/registration/search/qr?qrCode=${qrCode}`;
        console.log(`[API] Fetch URL: ${url}`);
        
        const response = await fetch(url);
        console.log(`[API] QR Search response status: ${response.status}`);
        
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to search by QR');
        }
        return response.json();
    },

    async searchByName(name) {
        console.log(`[API] Searching by name: ${name}`);
        const url = `${API_BASE}/api/registration/search/name?name=${name}`;
        console.log(`[API] Fetch URL: ${url}`);
        
        const response = await fetch(url);
        console.log(`[API] Name Search response status: ${response.status}`);
        
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to search by name');
        }
        return response.json();
    },

    async generateZPL(registration) {
        const response = await fetch(`${API_BASE}/api/registration/generate-zpl`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(registration)
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to generate ZPL');
        }
        return response.json();
    },

    async getEvents() {
        const response = await fetch(`${API_BASE}/api/events`);
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to fetch events');
        }
        return response.json();
    },

    async getTestZPL() {
        const response = await fetch(`${API_BASE}/api/registration/test-zpl`);
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to generate test ZPL');
        }
        return response.json();
    },

    async markBadgePrinted(registrationId) {
        const response = await fetch(`${API_BASE}/api/registration/mark-printed`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ registrationId })
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Failed to mark badge as printed');
        }
        return response.json();
    }
};
